import { render, staticRenderFns } from "./DigitalVoucherTable.vue?vue&type=template&id=87245b46&scoped=true"
import script from "./DigitalVoucherTable.vue?vue&type=script&lang=js"
export * from "./DigitalVoucherTable.vue?vue&type=script&lang=js"
import style0 from "./DigitalVoucherTable.vue?vue&type=style&index=0&id=87245b46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87245b46",
  null
  
)

export default component.exports